export default "__VITE_ASSET__66109eec__"